require("normalize.css/normalize.css");
require("./styles/index.scss");

import SimplexNoise from "./utils/SimplexNoise";
import * as dat from "dat.gui";

const canvas = document.querySelector(".main-canvas");
const simplex = new SimplexNoise();

let tick = 0;

let controls = {
  size: 2,
  clear: true,
  moving: true,
  white: false,
  grid: {
    width: 1000,
    height: 1000,
  },
  spacing: {
    x: 10,
    y: 10,
  },
  color: {
    speed: 0.01,
    red: 430,
    green: 75,
    blue: 200,
  },
  elevation: {
    speed: 0.001,
    intensity: 100,
  },
};

const initGUI = () => {
  let gui = new dat.GUI();

  gui
    .add(controls, "size")
    .step(0.1)
    .min(0)
    .max(20)
    .onChange(() => initPoints());

  gui.add(controls, "clear");
  gui.add(controls, "white");
  gui.add(controls, "moving").onChange(() => initPoints());

  let grid = gui.addFolder("grid");
  grid.open();
  grid
    .add(controls.grid, "width")
    .step(1)
    .min(500)
    .max(2000)
    .onChange(() => initPoints());
  grid
    .add(controls.grid, "height")
    .step(1)
    .min(500)
    .max(2000)
    .onChange(() => initPoints());

  let spacing = gui.addFolder("spacing");
  spacing.open();
  spacing
    .add(controls.spacing, "x")
    .step(1)
    .min(1)
    .max(30)
    .onChange(() => initPoints());
  spacing
    .add(controls.spacing, "y")
    .step(1)
    .min(1)
    .max(30)
    .onChange(() => initPoints());

  let color = gui.addFolder("color");
  color.add(controls.color, "speed").step(0.001).min(0).max(0.03);
  color.add(controls.color, "red").step(1).min(0).max(600);
  color.add(controls.color, "green").step(1).min(0).max(255);
  color.add(controls.color, "blue").step(1).min(0).max(600);

  let elevation = gui.addFolder("elevation");
  elevation.add(controls.elevation, "speed").step(0.001).min(0).max(0.1);
  elevation.add(controls.elevation, "intensity").step(1).min(0).max(5000);
};

// initGUI();

canvas.width = window.innerWidth * window.devicePixelRatio;
canvas.height = window.innerHeight * window.devicePixelRatio;

const ctx = canvas.getContext("2d");

class Point {
  constructor(x, y, size = controls.size) {
    this.x = x;
    this.y = y;
    this.size = size;
  }

  update() {}

  draw() {
    let noiseColor = simplex.noise3D(
      this.x / controls.grid.width,
      this.y / controls.grid.height,
      tick * controls.color.speed
    );
    let noiseElevation = simplex.noise3D(
      (this.x / controls.grid.width) * 2,
      (this.y / controls.grid.height) * 2,
      tick * controls.elevation.speed
    );
    ctx.save();
    ctx.translate(
      this.x,
      this.y + noiseElevation * controls.elevation.intensity
    );
    ctx.beginPath();
    if (controls.white) {
      ctx.fillStyle = `#fff`;
    } else {
      ctx.fillStyle = `rgba(${Math.abs(noiseColor * controls.color.red)}, ${
        controls.color.green
      }, ${Math.abs(noiseColor * controls.color.blue)}, 1)`;
    }
    ctx.arc(0, 0, this.size, 0, Math.PI * 2);
    ctx.fill();
    ctx.closePath();
    ctx.restore();
  }
}

let points = [];

const initPoints = () => {
  points = [];
  for (let y = 0; y < controls.grid.height; y += controls.spacing.y) {
    for (let x = 0; x < controls.grid.width; x += controls.spacing.x) {
      points.push(new Point(x, y));
    }
  }
};

initPoints();
console.log(points);

const update = () => {
  ctx.fillStyle = `rgba(0, 0, 0, ${controls.clear ? 1 : 0.01})`;
  ctx.rect(0, 0, canvas.width, canvas.height);
  ctx.fill();

  ctx.save();
  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.translate(-controls.grid.width / 2, -controls.grid.height / 2);

  if (controls.moving) {
    ctx.translate(0, -controls.spacing.y * tick);

    points.splice(0, controls.grid.width / controls.spacing.x);

    for (let x = 0; x < controls.grid.width; x += controls.spacing.x) {
      points.push(
        new Point(x, controls.grid.height + tick * controls.spacing.y)
      );
    }
  }

  points.forEach((point) => {
    point.draw();
  });

  ctx.restore();

  requestAnimationFrame(update);
  tick++;
};

requestAnimationFrame(update);
